import './App.css';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import ProtectedRoute from './utils/ProtectedRoute';
import NoPageFound from './pages/NoPageFound';
import Dashboard from './pages/Dashboard';
import Signin from './pages/Signin';
import Payment from './pages/Payment';
import Room from './pages/Room';
import ElectricityReport from './pages/water_and_electricity/ElectricityReport';
import BuildingMap from './pages/BuildingMap';
import PaymentReport from './pages/PaymentReport';
import VehicleProperty from './pages/VehicleProperty';
import WaterUsage from './pages/water_and_electricity/WaterUsage';
import MonthlyReportDetails from './pages/MonthlyReportDetails';
import PaymentReportPaid from './pages/PaymentReportPaid';
import PaymentReportUnpaid from './pages/PaymentReportUnpaid';
import InvoicePage from './pages/InvoicePage';
import Invoice1 from './components/InvoiceForPriting';
import MonthlyReport from './pages/MonthlyReport';
import Electricity from './pages/water_and_electricity/ElectricityUsage';
import PaymentReportDaily from './pages/PaymentReportDaily';

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/signin" element={<Signin />} />

      {/* Protect all routes under "/" */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path='payment' element={<Payment />} />
        <Route path='room' element={<Room />} />
        <Route path='payment-report' element={<PaymentReport />} />
        <Route path='payment-report-paid' element={<PaymentReportPaid />} />
        <Route path='payment-report-unpaid' element={<PaymentReportUnpaid />} />
        <Route path='payment-report-daily' element={<PaymentReportDaily />} />
        <Route path='electricity-report' element={<ElectricityReport />} />
        <Route path='water-usage' element={<WaterUsage />} />
        <Route path='electricity-usage' element={<Electricity />} />
        <Route path='vehicle' element={<VehicleProperty />} />
        <Route path='building-map' element={<BuildingMap />} />
        <Route path='monthly-report' element={<MonthlyReport />} />
        <Route path='monthly-report-details' element={<MonthlyReportDetails />} />
        <Route path='invoice' element={<InvoicePage />} />
        <Route path='invoice1' element={<Invoice1 />} />
      </Route>
      <Route path="*" element={<NoPageFound />} />
    </>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
